import { TriggerFieldInputProps } from '../types';
import NumberField from './NumberField';
import SelectButtonsField from './SelectButtonsField';
import SelectField from './SelectField';
import StringField from './StringField';
import StringMultiLineField from './StringMultiLineField';
import ExoField from './ExoField';

interface TriggerFieldOption {
    component: (props: TriggerFieldInputProps) => JSX.Element | null;
    type?: string;
    autoComplete?: string;
}

export default {
    String: {
        component: StringField,
    },
    StringMultiline: {
        component: StringMultiLineField,
    },
    Boolean: {
        component: ExoField,
        type: 'checkbox',
    },
    Date: {
        component: ExoField,
        type: 'date',
    },
    DateTime: {
        component: ExoField,
        type: 'datetime-local',
    },
    Number: {
        component: NumberField,
        type: 'number',
    },
    SingleSelect: {
        component: SelectField,
    },
    MultiSelect: {
        component: SelectField,
    },
    PhoneNumber: {
        component: ExoField,
        type: 'tel',
        autoComplete: 'tel',
    },
    SingleSelectButtons: {
        component: SelectButtonsField,
        type: 'radio',
    },
    MultiSelectButtons: {
        component: SelectButtonsField,
        type: 'checkbox',
    },
} as { [key: string]: TriggerFieldOption };
